module.exports = __webpack_public_path__ + "static/media/photo_4.d11c518c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_4.jpg
// module id = 1637
// module chunks = 0